import { LazyUserCell } from 'app/components/LazyUserCell'
import { useStaff } from 'app/components/staff/useStaff'
import { StaffShadcnComponent } from 'app/components/staff/StaffShadcnComponent'

export default function StaffIndex(): React.ReactElement {
  const { staff, canManageStaff, openCreateModal, openEditModal } = useStaff()

  return (
    <StaffShadcnComponent
      staff={staff}
      canManageStaff={canManageStaff}
      onCreateStaff={openCreateModal}
      onEditStaff={openEditModal}
      renderUserCell={(userId) => <LazyUserCell userId={userId} loadingIndicator />}
    />
  )
}
